import { useEffect, useState } from 'react';
import ReactGA from 'react-ga4';
import { Grid, Header, Container } from 'semantic-ui-react';
import { useUserContext } from '~/hooks';
import { useTutorials } from '~/hooks/providers/TutorialProvider';
import { useProjectList } from '~/requests/projects/useProjectList';
import CreateProject from './CreateProject';
import CreateFromDocumentProgressIndicator from '~/features/createFromDocument/CreateFromDocumentProgressIndicator';

import './styles.scss';

import ProjectTable from './ProjectTable';
import ProjectFilters from './ProjectFilters';
import { ProjectFiltersType } from '~/types/project/ProjectFiltersType';


export default function ProjectSearch() {
  const { loggedInUser } = useUserContext();
  const { setTutorialContext } = useTutorials() as any;
  const { data: projects } = useProjectList();
  const [filters, setFilters] = useState<ProjectFiltersType>({
    selectedStatuses: [],
    selectedOwners: [],
    hasOpenItems: false,
    includeArchived: false,
    selectedPricingType: '',
    selectedDeploymentType: '',
    selectedDevelopmentStage: '',
    developerName: '',
    investorName: '',
    state: ''
  });

  ReactGA.send({ hitType: 'pageview', page: '/my-deals', title: loggedInUser?.isAdmin ? 'All Deals' : 'My Deals' });

  useEffect(() => {
    const pageTitle = loggedInUser?.isAdmin ? 'All Deals | Conductor Solar' : 'My Deals | Conductor Solar';
    document.title = pageTitle;
  }, [loggedInUser?.isAdmin]);

  useEffect(() => {
    setTutorialContext({
      page: 'dashboard',
      data: {
        projects
      }
    });
  }, [projects]);

  const handleFiltersChange = (filters: any) => {
    setFilters(filters);
  };

  return (
    <div className="project-search-container">
      <Container fluid={loggedInUser?.isAdmin ? true : false}>
        <Grid centered>
          <Grid.Column mobile={12} tablet={12} computer={12} largeScreen={12}>
            <Header as="h1" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
              <span>{loggedInUser?.isAdmin ? 'All ' : 'My '}Deals</span>
              {(loggedInUser?.isInstaller || loggedInUser?.isAdmin) && (
                <CreateProject />
              )}
            </Header>

            {loggedInUser?.isAdmin && (
              <CreateFromDocumentProgressIndicator />
            )}

            <div className="card">
              <ProjectFilters setActiveFilters={handleFiltersChange} />
            </div>
            <div className="card">
              <ProjectTable projectFilters={filters} />
            </div>
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
}